import * as React from 'react';
import cn from 'clsx';
import { useDeviceType, ArticleParagraph1, InformationTooltip, UIHeading4, Button, UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

import { IBankInfoModalContent } from 'shared/mortgageMiniCalculator/types/modal';
import { PskTooltipContent } from 'shared/mortgageMiniCalculator/components/PskTooltipContent';

import styles from './styles.css';
import { Layout } from '../Layout';
import { ETestIds } from '../../../../constants';

interface IBankInfoModalContentProps {
  creditInfo: IBankInfoModalContent;
  onClick: () => void;
}

export const BankInfoModalContent: React.FC<IBankInfoModalContentProps> = ({ creditInfo, onClick }) => {
  const deviceType = useDeviceType();
  const { offerName, offerDescription, iconPath, rows, button } = creditInfo;

  return (
    <Layout
      headerName={offerName}
      headerDescription={offerDescription}
      headerLogoUrl={iconPath}
      testId={ETestIds.BankModal}
      content={
        <>
          <UIHeading4>Все условия кредита</UIHeading4>
          <ul className={cn(styles['list'], styles[deviceType])}>
            {rows.map((el, index) => {
              return (
                <li key={index} className={cn(styles['item'], styles[deviceType])}>
                  <ArticleParagraph1 color="gray60_100">
                    {el.key}
                    {el.tooltip && (
                      <InformationTooltip placement={'right-start'} content={<PskTooltipContent />} header={el.tooltip}>
                        <span className={styles['tooltip-icon']}>
                          <IconFunctionalInformationCircle16 />
                        </span>
                      </InformationTooltip>
                    )}
                  </ArticleParagraph1>
                  <ArticleParagraph1>{el.value}</ArticleParagraph1>
                </li>
              );
            })}
          </ul>
        </>
      }
      button={
        <div className={cn(styles['button'], styles[deviceType])}>
          <Button onClick={onClick} data-testid={ETestIds.BankButton}>
            {button.text}
          </Button>
          <UIText2 color={'text-secondary-default'}>Заявка единая для всех банков</UIText2>
        </div>
      }
    />
  );
};
